import { isFeatureEnabled } from 'owa-feature-flags';
export default function isDeprecateLegacyPremiumEnabled() {
    return isFeatureEnabled('auth-PremiumDeprecateLegacyPremium');
}
